import { exists as e } from "../runtime.js";
import { AutoRenewSubmitDetailFromJSON as d, AutoRenewSubmitDetailToJSON as m } from "./AutoRenewSubmitDetail.js";
import { AutoRenewalVerificationStatusFromJSON as s, AutoRenewalVerificationStatusToJSON as p } from "./AutoRenewalVerificationStatus.js";
import { CitizenshipFromJSON as r, CitizenshipToJSON as n } from "./Citizenship.js";
import { CoAppDocumentFromJSON as u, CoAppDocumentToJSON as c } from "./CoAppDocument.js";
import { ContactFromJSON as l, ContactToJSON as S } from "./Contact.js";
import { GenderFromJSON as I, GenderToJSON as N } from "./Gender.js";
import { InternationalSponsorFromJSON as g, InternationalSponsorToJSON as f } from "./InternationalSponsor.js";
import { MaritalStatusCdFromJSON as R, MaritalStatusCdToJSON as h } from "./MaritalStatusCd.js";
import { MinorDocumentFromJSON as y, MinorDocumentToJSON as T } from "./MinorDocument.js";
import { PersonalIdFromJSON as t, PersonalIdToJSON as o } from "./PersonalId.js";
import { SignInIdFlowFromJSON as D, SignInIdFlowToJSON as C } from "./SignInIdFlow.js";
import { SignatureFromJSON as O, SignatureToJSON as J } from "./Signature.js";
import { TaxIdFromJSON as A, TaxIdToJSON as w } from "./TaxId.js";
import { UsernameContactTypeFromJSON as v, UsernameContactTypeToJSON as b } from "./UsernameContactType.js";
const H = {
  Terms: "TERMS",
  PersonalData: "PERSONAL_DATA",
  CommunicationAuthorization: "COMMUNICATION_AUTHORIZATION"
};
function Z(i) {
  return !0;
}
function Q(i) {
  return P(i);
}
function P(i, a) {
  return i == null ? i : {
    givenName: e(i, "givenName") ? i.givenName : void 0,
    familyName: e(i, "familyName") ? i.familyName : void 0,
    sponsor: e(i, "sponsor") ? i.sponsor : void 0,
    doNotKnowSponsor: e(i, "doNotKnowSponsor") ? i.doNotKnowSponsor : void 0,
    internationalSponsor: e(i, "internationalSponsor") ? g(i.internationalSponsor) : void 0,
    multipleBusinessFlag: e(i, "multipleBusinessFlag") ? i.multipleBusinessFlag : void 0,
    extensions: e(i, "extensions") ? i.extensions : void 0,
    partyId: e(i, "partyId") ? i.partyId : void 0,
    personalId: e(i, "personalId") ? t(i.personalId) : void 0,
    personalIdList: e(i, "personalIdList") ? i.personalIdList.map(t) : void 0,
    taxRegime: e(i, "taxRegime") ? i.taxRegime : void 0,
    spousePersonalId: e(i, "spousePersonalId") ? t(i.spousePersonalId) : void 0,
    consentAccepted: e(i, "consentAccepted") ? i.consentAccepted : void 0,
    taxId: e(i, "taxId") ? A(i.taxId) : void 0,
    billingAddress: e(i, "billingAddress") ? l(i.billingAddress) : void 0,
    birthDate: e(i, "birthDate") ? new Date(i.birthDate) : void 0,
    gender: e(i, "gender") ? I(i.gender) : void 0,
    isMinor: e(i, "isMinor") ? i.isMinor : void 0,
    minorDocuments: e(i, "minorDocuments") ? i.minorDocuments.map(y) : void 0,
    coAppDocuments: e(i, "coAppDocuments") ? i.coAppDocuments.map(u) : void 0,
    signature: e(i, "signature") ? O(i.signature) : void 0,
    citizenship: e(i, "citizenship") ? r(i.citizenship) : void 0,
    citizenshipCountry: e(i, "citizenshipCountry") ? i.citizenshipCountry : void 0,
    spouseCitizenship: e(i, "spouseCitizenship") ? r(i.spouseCitizenship) : void 0,
    spouseCitizenshipCountry: e(i, "spouseCitizenshipCountry") ? i.spouseCitizenshipCountry : void 0,
    maritalStatus: e(i, "maritalStatus") ? R(i.maritalStatus) : void 0,
    phone: e(i, "phone") ? i.phone : void 0,
    email: e(i, "email") ? i.email : void 0,
    accountNumber: e(i, "accountNumber") ? i.accountNumber : void 0,
    verifyPersonalId: e(i, "verifyPersonalId") ? i.verifyPersonalId : void 0,
    fullUrl: e(i, "fullUrl") ? i.fullUrl : void 0,
    invitationLink: e(i, "invitationLink") ? i.invitationLink : void 0,
    challengeId: e(i, "challengeId") ? i.challengeId : void 0,
    prePrintedKitId: e(i, "prePrintedKitId") ? i.prePrintedKitId : void 0,
    reservedAccountNumber: e(i, "reservedAccountNumber") ? i.reservedAccountNumber : void 0,
    orderRequired: e(i, "orderRequired") ? i.orderRequired : void 0,
    signInIdFlow: e(i, "signInIdFlow") ? D(i.signInIdFlow) : void 0,
    usernameContactType: e(i, "usernameContactType") ? v(i.usernameContactType) : void 0,
    autoRenewalVerificationStatus: e(i, "autoRenewalVerificationStatus") ? s(i.autoRenewalVerificationStatus) : void 0,
    autoRenewalPaymentVerificationSubmitDateTime: e(i, "autoRenewalPaymentVerificationSubmitDateTime") ? new Date(i.autoRenewalPaymentVerificationSubmitDateTime) : void 0,
    autoRenewDetails: e(i, "autoRenewDetails") ? d(i.autoRenewDetails) : void 0,
    otpRequestId: e(i, "otpRequestId") ? i.otpRequestId : void 0,
    version: e(i, "version") ? i.version : void 0,
    identityJWT: e(i, "identityJWT") ? i.identityJWT : void 0
  };
}
function X(i) {
  if (i !== void 0)
    return i === null ? null : {
      givenName: i.givenName,
      familyName: i.familyName,
      sponsor: i.sponsor,
      doNotKnowSponsor: i.doNotKnowSponsor,
      internationalSponsor: f(i.internationalSponsor),
      multipleBusinessFlag: i.multipleBusinessFlag,
      extensions: i.extensions,
      partyId: i.partyId,
      personalId: o(i.personalId),
      personalIdList: i.personalIdList === void 0 ? void 0 : i.personalIdList.map(o),
      taxRegime: i.taxRegime,
      spousePersonalId: o(i.spousePersonalId),
      consentAccepted: i.consentAccepted,
      taxId: w(i.taxId),
      billingAddress: S(i.billingAddress),
      birthDate: i.birthDate === void 0 ? void 0 : i.birthDate.toISOString().substring(0, 10),
      gender: N(i.gender),
      isMinor: i.isMinor,
      minorDocuments: i.minorDocuments === void 0 ? void 0 : i.minorDocuments.map(T),
      coAppDocuments: i.coAppDocuments === void 0 ? void 0 : i.coAppDocuments.map(c),
      signature: J(i.signature),
      citizenship: n(i.citizenship),
      citizenshipCountry: i.citizenshipCountry,
      spouseCitizenship: n(i.spouseCitizenship),
      spouseCitizenshipCountry: i.spouseCitizenshipCountry,
      maritalStatus: h(i.maritalStatus),
      phone: i.phone,
      email: i.email,
      accountNumber: i.accountNumber,
      verifyPersonalId: i.verifyPersonalId,
      fullUrl: i.fullUrl,
      invitationLink: i.invitationLink,
      challengeId: i.challengeId,
      prePrintedKitId: i.prePrintedKitId,
      reservedAccountNumber: i.reservedAccountNumber,
      orderRequired: i.orderRequired,
      signInIdFlow: C(i.signInIdFlow),
      usernameContactType: b(i.usernameContactType),
      autoRenewalVerificationStatus: p(i.autoRenewalVerificationStatus),
      autoRenewalPaymentVerificationSubmitDateTime: i.autoRenewalPaymentVerificationSubmitDateTime === void 0 ? void 0 : i.autoRenewalPaymentVerificationSubmitDateTime.toISOString(),
      autoRenewDetails: m(i.autoRenewDetails),
      otpRequestId: i.otpRequestId,
      version: i.version,
      identityJWT: i.identityJWT
    };
}
export {
  H as RegistrationPatchRequestConsentAcceptedEnum,
  Q as RegistrationPatchRequestFromJSON,
  P as RegistrationPatchRequestFromJSONTyped,
  X as RegistrationPatchRequestToJSON,
  Z as instanceOfRegistrationPatchRequest
};
//# sourceMappingURL=RegistrationPatchRequest.js.map
